import authorization from "./authorization.component";
import authorizationUrls from "./authorization.urls";
import AuthorizationTransforms from "./authorization.transforms";

const authorizationModule = angular
  .module("app.components.authorization", [])
  .component("authorizationPage", authorization)
  .service("AuthorizationTransforms", AuthorizationTransforms)
  .config(authorizationUrls);

export default authorizationModule;



// WEBPACK FOOTER //
// ./src/pages/authorization/authorization.module.js